import { ChangeEvent, FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Paper, Tab, Tabs } from '@material-ui/core';
import { useStylesSecond } from './styles';
import TabPanel from 'components/TabPanel';
import { InfoTable } from './InfoTable';
import { SyncUser } from './SyncUser';
import { SyncGroup } from './SyncGroup';
import { SyncDepartment } from './SyncDepartment';
import { useLocation } from 'react-router-dom';
import AppTimeline from './AppTimeline';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
function useQuer() {
  return new URLSearchParams(useLocation().search);
}
export const GoogleTable: FC = observer(() => {
  const classes = useStylesSecond();
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }
  const {
    ldapStore: { getGoogleTimeline },
    notificationStore: { openNotification },
  } = useStore();

  const query = useQuer();
  const queryValue = query.get('value');
  const defaultTabs = (Array.isArray(queryValue) ? queryValue[0] : queryValue) ?? 'one';
  const [value, setValue] = useState<string>(defaultTabs);

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  const googletimelineReq = useQuery(['googleTimeline', 'apps'], () => getGoogleTimeline('google'), {
    enabled: value === 'five',
    onError: () => {
      openNotification('error', "Can't get google timeline");
    },
  });

  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <Tabs
          value={value}
          className={classes.tabs}
          TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
          onChange={handleChange}
        >
          <Tab value='one' wrapped label={<span>INFO</span>} {...a11yProps('one')} className={classes.label} />
          <Tab value='two' wrapped label={<span>Users</span>} {...a11yProps('two')} className={classes.label} />
          <Tab value='three' wrapped label={<span>Groups</span>} {...a11yProps('three')} className={classes.label} />
          <Tab value='four' wrapped label={<span>Departments</span>} {...a11yProps('four')} className={classes.label} />
          <Tab value='five' wrapped label={<span>Timeline</span>} {...a11yProps('four')} className={classes.label} />
        </Tabs>

        <div className={classes.tabBox}>
          <TabPanel value={value} index='one'>
            <InfoTable />
          </TabPanel>
          <TabPanel value={value} index='two'>
            <SyncUser />
          </TabPanel>
          <TabPanel value={value} index='three'>
            <SyncGroup />
          </TabPanel>
          <TabPanel value={value} index='four'>
            <SyncDepartment />
          </TabPanel>
          <TabPanel value={value} index='five'>
            <AppTimeline header='user' events={googletimelineReq.data || []} loading={googletimelineReq.isLoading} />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
});
